import { nb, enUS } from 'date-fns/locale';

export function useDateLocale(lang: string): Locale {
  if (lang === 'nb') {
    return nb;
  }

  return enUS;
}

export default useDateLocale;
